<template>
    <div>
        <div class="smallContent miscContent">
            <div id="cart" v-if="store.cart.items.length">
                <!-- <div class="item"> -->
                <!--     <div>Cart</div> -->
                <!--     <div></div> -->
                <!--     <div></div> -->
                <!-- </div> -->
                <div v-for="item in getSorted" class="item">
                    <div>
                        {{ item.title }}
                        <span v-if="item.option">({{ item.option }})</span>
                    </div>

                    <div class="quant">
                        <div>

                            Quantity:
                        </div>
                        <img class="modify" src="../assets/MPR_Icons_minus.svg" @click="remove(item)">
                        <div class="noBreak tabNum">
                            {{ item.amount }}
                        </div>
                        <img class="modify" src="../assets/MPR_Icons_plus.svg" @click="add(item)">
                    </div>
                    <div class="price tabNum">
                        {{ formatPrice(getItemTotal(item)) }}
                    </div>
                </div>
                <div class="item empty">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="item">
                    <div>Subtotal</div>
                    <div></div>
                    <div class="price tabNum">${{ getItemsTotal }}</div>
                </div>
                <div class="item">
                    <div>Taxes</div>
                    <div></div>
                    <div class="price tabNum">${{ getTaxesDisplay }}</div>
                </div>
                <div class="item">
                    <div>Shipping</div>
                    <div v-if="this.store.cart.shipping.id == 0 &&
                        shippingVisible == false
                        " @click="shippingVisible = true" class="grey cursor">
                        Select Country
                    </div>
                    <div v-if="this.store.cart.shipping.id == 0 &&
                        shippingVisible == false
                        "></div>
                    <div v-if="shippingVisible == true" id="shippingSelect">
                        <div class="shippingRow cursor grey" v-for="shipping in shippings.filter(s => s.title != 'Tax')"
                            @click="addShipping(shipping)">
                            <div>
                                {{ shipping.title }}
                            </div>
                            <div class="tabNum">${{ shipping.price.toFixed(2) }}</div>
                        </div>
                    </div>
                    <div v-if="this.store.cart.shipping.id != 0 &&
                        shippingVisible == false
                        " @click="shippingVisible = true" class="cursor">
                        {{ this.store.cart.shipping.title }}
                    </div>
                    <div v-if="this.store.cart.shipping.id != 0 &&
                        shippingVisible == false
                        " class="price cursor tabNum" @click="shippingVisible = true">
                        ${{ this.store.cart.shipping.price.toFixed(2) }}
                    </div>
                </div>
                <div class="item" v-show="this.store.cart.shipping.id != 0">
                    <div>Total</div>
                    <div></div>
                    <div class="price tabNum">${{ getTotal }}</div>
                </div>
                <div class="item" id="paypalContainer" v-show="this.store.cart.shipping.id != 0">
                    <div id="paypalText">
                        Your items will be shipped to the address you have on
                        file with PayPal. Please check carefully that your
                        address is correct on the next screen, and change it if
                        this is not the case.
                    </div>
                    <div id="paypal-button-container"></div>
                </div>
            </div>
            <div v-else-if="paid">Thank you for your purchase. Please check your email for a receipt. Your item will ship
                within 1–3 weeks.</div>
            <div v-else>Your cart is empty.</div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from "./Footer.vue";
import { store } from "../store";
import axios from "axios";
import { loadScript } from "@paypal/paypal-js";
export default {
    name: "Cart",
    components: {
        Footer,
    },
    activated() {
        loadScript({
            "client-id":
                "AQZjWrT3uwzJbqHRdCf8V6GKWpffvqD_lUEY4fvxUJhRe2mkmUOUMUw9Cpa64ySnJBYBfVh_J3J_aW3I",
            "disable-funding": "credit,giropay,bancontact,paylater,sepa,sofort",
        }).then((paypal) => {
            paypal
                .Buttons({
                    style: {
                        shape: "rect",
                        color: "white",
                        layout: "vertical",
                    },
                    createOrder: this.createOrder,
                    onApprove: this.onApprove,
                })
                .render("#paypal-button-container");
        });
    },
    data() {
        return {
            store: store,
            shippings: [],
            shippingVisible: false,
            PayPalButton: null,
            paid: false,
        };
    },
    computed: {
        getTotal() {
            let total = 0;
            this.store.cart.items.forEach((i) => (total += i.amount * i.price));
            total += this.store.cart.shipping.price;
            total += this.getTaxes;
            return total.toFixed(2);
        },
        getItemsTotal() {
            let total = 0;
            this.store.cart.items.forEach((i) => (total += i.amount * i.price));
            return total.toFixed(2);
        },
        getSorted() {
            let sorted = this.store.cart.items.toSorted(function (a, b) {
                if (a.title < b.title) {
                    return -1;
                }
                if (a.title > b.title) {
                    return 1;
                }
                return 0;
            });
            return sorted;
        },
        getTaxes() {
            if (this.shippings.length) {
                let taxes = this.getItemsTotal * (this.shippings.find(s => s.title == 'Tax').price / 100)
                return Number((taxes).toFixed(2))
            } else {
                return 0
            }
        },
        getTaxesDisplay() {
            return parseFloat(this.getTaxes).toFixed(2)

        },
        getItems() {
            let itemList = []
            this.store.cart.items.forEach((i) => {
                let ob = {
                    name: i.option ? i.title + ' ' + i.option : i.title,
                    unit_amount: {
                        currency_code: "USD",
                        value: i.price
                    },
                    quantity: i.amount,

                }
                itemList.push(ob)
            })
            return itemList
        }
    },
    mounted: function () {
        let myself = this;
        axios.get("/api/get-shippings").then((response) => {
            this.shippings = response.data.shippings;
        });
    },
    methods: {
        addShipping(shipping) {
            this.store.cart.shipping = {
                id: shipping.id,
                title: shipping.title,
                price: shipping.price,
            };
            this.shippingVisible = false;
        },
        add(item) {
            item.amount += 1;
        },
        remove(item) {
            item.amount -= 1;
            if (item.amount < 1) {
                let index = this.store.cart.items.indexOf(item);
                this.store.cart.items.splice(index, 1);
                if (this.store.cart.items.length == 0) {
                    this.clear();
                }
                // this.store.cart.items = this.store.cart.items.filter(
                // (i) => i.pk != item.pk
                // );
            }
        },
        clear() {
            this.store.cart.items = [];
            this.store.cart.shipping = {
                id: 0,
                title: "",
                price: 0,
            };
        },
        getItemTotal: function (item) {
            return item.amount * item.price;
        },
        formatPrice(price) {
            return "$" + price.toFixed(2);
        },
        createOrder: function (data, actions) {
            return actions.order.create({
                // purchase_units: [
                //     {
                //         amount: {
                //             value: this.getTotal,
                //         },
                //     },
                // ],
                purchase_units: [{
                    description: "Montez Press Radio",
                    amount: {
                        currency_code: "USD",
                        value: this.getTotal,
                        breakdown: {
                            item_total: {
                                currency_code: "USD",
                                value: this.getItemsTotal
                            },
                            shipping: {
                                currency_code: "USD",
                                value: this.store.cart.shipping.price
                            },
                            tax_total: {
                                currency_code: "USD",
                                value: this.getTaxes
                            },
                        }
                    },
                    items: this.getItems
                }]
            });
        },
        onApprove: function (data, actions) {
            return actions.order.capture().then(() => {
                this.paid = true;
                this.clear();
            });
        },
    },
};
</script>
<style scoped>
#cart {
    display: grid;
    grid-template-columns: 3fr 3fr 1fr;
}

.item {
    display: contents;
}

.item>div {
    border-bottom: 1px solid black;
    padding: 0.6rem 0.5rem 0.7rem;
}

.item.empty>div {
    padding: 0.6rem 0.5rem 0rem;
}

.item>div:first-child {
    padding-left: 0;
}

.item>div:last-child {
    padding-right: 0;
}

.price {
    text-align: right;
}

.modify {
    /* margin: 0 0.5rem; */
    /* padding: 0.2rem 0.7rem; */
    cursor: pointer;
    width: 1.8rem;
}

#shippingSelect {
    grid-column: span 2;
    /* display: grid; */
    /* grid-template-columns: 1fr 1fr; */
}

.shippingRow {
    display: flex;
    justify-content: space-between;
}

.cursor {
    cursor: pointer;
}

.grey {
    color: grey;
}

.grey:hover {
    color: black;
}

#paypal-button-container {
    padding: 0.8rem 0.5rem;
    grid-column-start: 1;
    grid-column-end: 4;
}

#paypalText {
    grid-column-start: 1;
    grid-column-end: 4;
    order: 100;
    font-family: Montez Small;
    font-size: 1rem;
    line-height: 1.333rem;

}

@media only screen and (min-width: 738px) {
    #paypal-button-container {

        grid-column-start: 2;
    }

    #paypalText {
        grid-column-end: 2;
        order: unset;
    }
}

#gridSpacer {
    display: none;
}

@media only screen and (min-width: 738px) {
    #gridSpacer {
        /* display: block; */
    }
}

#paypalContainer>div {
    border-bottom: none;
}

.noBreak {
    white-space: nowrap;
}

.tabNum {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on, "case" on;
}

.quant {
    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
}
</style>
